module.exports = {
	SUCCESS: 'SUCCESS',
	FAILURE: 'FAILURE',
	ERROR: 'ERROR',
	NOACTION: 'NOACTION'
};


//////////////////
// WEBPACK FOOTER
// ./constants/actionCodes.js
// module id = 35
// module chunks = 0 5 20